import { useEffect, useRef } from "react";
import { useTheme, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { autoSetViewBox } from "utils/helpers/svg";

import { ReactComponent as EnboqLogo } from "assets/svg/Enboq-Logo-NoPayoff-Svg.svg";
import { ReactComponent as EnboqWhiteLogo } from "assets/svg/Enboq-Logo-NoPayoff-White-Svg.svg";

type Props = {
	type?: "img" | "backgroundImg";
	size?: {
		width?: number | string;
		height?: number | string;
		maxWidth?: number | string;
		maxHeight?: number | string;
		margin?: string | number;
	};
};

export const OrganizationLogo = ({ type = "backgroundImg", size }: Props) => {
	const theme = useTheme();
	const logoUrl = theme.organization.logoURI;
	const classes = useStyles({ size, logoUrl });

	const svgRef = useRef<SVGSVGElement>(null);
	const svgWhiteRef = useRef<SVGSVGElement>(null);

	useEffect(() => {
		const timeout = setTimeout(() => {
			autoSetViewBox(svgRef.current);
			autoSetViewBox(svgWhiteRef.current);
		}, 50);

		return () => clearTimeout(timeout);
	}, []);

	return (
		<>
			{type === "backgroundImg" ? (
				logoUrl ===
				"https://riddlestory-common-assets.s3.eu-central-1.amazonaws.com/logo/Enboq-Logo-NoPayoff-Svg.svg" ? (
					<>
						<EnboqLogo
							ref={svgRef}
							data-testid="organization_logo"
							className={classes.backgroundImg + " EnboqLogo"}
						/>
						<EnboqWhiteLogo
							ref={svgWhiteRef}
							data-testid="organization_logo"
							className={classes.backgroundImg + " EnboqWhiteLogo"}
						/>
					</>
				) : (
					<div data-testid="organization_logo" className={classes.backgroundImg}></div>
				)
			) : (
				<img src={`${logoUrl}`} className={classes.img} alt="company logo" />
			)}
		</>
	);
};

const useStyles = makeStyles<Theme, { logoUrl?: string; size?: Props["size"] }>((theme) => ({
	backgroundImg: ({ logoUrl }) => ({
		...(logoUrl !==
		"https://riddlestory-common-assets.s3.eu-central-1.amazonaws.com/logo/Enboq-Logo-NoPayoff-Svg.svg"
			? {
					background: `url(${theme.organization.logoURI}) no-repeat center`,
					backgroundSize: "contain",
					width: "428px",
					height: "96px",
			  }
			: {
					width: "300px",

					"&.EnboqWhiteLogo": {
						display: "none",
					},
			  }),
		[theme.breakpoints.down("mobile")]: {
			"&.EnboqWhiteLogo": {
				display: "block",
			},
			"&.EnboqLogo": {
				display: "none",
			},
			width: ({ size }: any) => (size?.width ? size.width : "55%"),
			...(logoUrl !==
				"https://riddlestory-common-assets.s3.eu-central-1.amazonaws.com/logo/Enboq-Logo-NoPayoff-Svg.svg" && {
				height: ({ size }: any) => (size?.height ? size.height : "65px"),
			}),
			margin: ({ size }: any) => (size?.margin ? size.margin : "0 0 0 22.5%"),
		},
	}),
	img: {
		marginBottom: 16,
		[theme.breakpoints.down("mobile")]: {
			width: "100%",
			maxWidth: ({ size }: any) => (size ? size.maxWidth : 120),
		},
	},
}));
